import React from 'react';
import { Sparkles } from 'lucide-react';

const suggestionsFor = (language) => (language === 'fr'
  ? ['Fais-moi un diagnostic complet', 'Quelles sont mes priorit\u00e9s ?', 'Plan d\'optimisation 3 mois']
  : ['Give me a full diagnosis', 'What are my priorities?', '3-month optimization plan']);

export const ChatEmptyState = ({ language, onSuggestion }) => (
  <div className="flex flex-col items-center justify-center py-16 text-center" data-testid="chat-empty-state">
    <div className="p-4 rounded-2xl bg-lux-gold/10 mb-4">
      <Sparkles className="w-8 h-8 text-[var(--lux-gold)]" />
    </div>
    <h3 className="font-display text-xl text-white mb-2">
      {language === 'fr' ? 'Bienvenue chez votre Coach' : 'Welcome to your Coach'}
    </h3>
    <p className="text-white/40 text-sm max-w-md">
      {language === 'fr'
        ? 'Posez vos questions, envoyez une photo pour une analyse, ou demandez un plan d\'optimisation complet.'
        : 'Ask your questions, send a photo for analysis, or request a complete optimization plan.'}
    </p>
    <div className="flex flex-wrap gap-2 mt-6 justify-center">
      {suggestionsFor(language).map((suggestion, i) => (
        <button
          key={suggestion}
          data-testid={`chat-suggestion-${i}`}
          onClick={() => onSuggestion(suggestion)}
          className="text-xs px-3 py-2 rounded-lg bg-white/5 border border-white/10 text-white/60 hover:bg-white/8 hover:text-white/80 transition-colors duration-200"
        >
          {suggestion}
        </button>
      ))}
    </div>
  </div>
);
